var _g, _g2, _g3, _g4, _g5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgProductsActive = function SvgProductsActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 715 576",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_204_6328)",
    "data-tip": "true",
    "data-for": "mlem-tooltip",
    "data-product": "mlem",
    className: "product mlem"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.573 177.775c-.084 1 .535 2.016 1.858 2.779l117.097 67.601c2.487 1.436 6.52 1.436 9.007.001l117.085-67.595c1.323-.763 1.942-1.779 1.858-2.779 2.744 2.431 2.177 5.65-1.396 7.713l-115.295 66.561c-3.731 2.153-9.78 2.153-13.511-.001L171.97 185.488c-3.573-2.063-4.14-5.282-1.397-7.713Z",
    fill: "#81E3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 145.549,
    height: 145.564,
    rx: 4,
    transform: "scale(1.22477 .70707) rotate(-45 372.417 -39.688)",
    fill: "url(#paint0_linear_204_6328)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 145.549,
    height: 145.564,
    rx: 4,
    transform: "scale(1.22477 .70707) rotate(-45 372.417 -39.688)",
    fill: "url(#paint1_linear_204_6328)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_204_6328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.248 148.672c-5.75-1.923-12.872.339-13.043 4.143l-.693 15.26c-.033.731-.545 1.422-1.433 1.935-.887.512-2.085.808-3.351.827l-26.434.399c-6.589.099-10.504 4.211-7.175 7.53l15.672 15.624c8.58 8.553 25.89 12.854 42.321 10.516 7.431-1.058 14.241-3.19 19.795-6.199 3.523-1.915 4.26-10.511.813-12.503a.943.943 0 0 0-.262-.096 1.246 1.246 0 0 0-.306-.026 1.144 1.144 0 0 0-.294.051.698.698 0 0 0-.228.116 25.42 25.42 0 0 1-2.945 1.976l-6.468 3.734c-3.833 2.212-8.646 3.777-13.934 4.53-4.82.687-9.927.439-14.539-.707s-8.474-3.126-10.995-5.638l-8.34-8.312c-.217-.217-.335-.462-.342-.711-.006-.249.098-.494.305-.71.206-.217.507-.398.873-.526a3.877 3.877 0 0 1 1.215-.205l11.921-.18c10.503-.159 18.862-4.985 19.137-11.048l.313-6.883c.011-.248.134-.49.355-.701.222-.211.535-.384.91-.503s.798-.18 1.229-.177c.431.004.855.072 1.232.197l13.893 4.646c.856.286 1.67.6 2.444.937.436.187.949.303 1.486.336a4.9 4.9 0 0 0 1.56-.149c2.609-.691 5.486-.996 8.374-.887 2.574.096 5.355-1.685 3.667-2.826-2.889-1.953-6.333-3.607-10.179-4.892l-26.553-8.877-.001-.001Z",
    fill: "url(#paint2_linear_204_6328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.598 180.471c-3.578-2.066-3.572-5.938.83-8.48 3.319-1.915 8.683-1.956 12.53.265 3.846 2.221 3.776 5.318.458 7.233-.68.392-1.218.857-1.585 1.37-.366.513-.554 1.063-.552 1.619.002.556.194 1.106.564 1.621.37.514.912.982 1.595 1.376.683.394 1.493.707 2.384.92.891.214 1.845.325 2.807.326.963.001 1.916-.108 2.804-.319.888-.212 1.694-.523 2.372-.915 9.538-5.506 8.563-13.971-.501-19.203-9.065-5.234-23.727-5.797-33.265-.29-9.065 5.233-11.104 14.495-.789 20.449l9.523 5.498c1.463.846 2.428 1.935 2.756 3.113.327 1.178.001 2.383-.932 3.443-.131.148.157.299.36.181l2.157-1.244c7.142-4.124 7.117-10.824-.055-14.964l-3.464-1.999h.003Z",
    fill: "url(#paint3_linear_204_6328)"
  })), /*#__PURE__*/React.createElement("circle", {
    transform: "scale(1.22477 .70707) rotate(-45 549.238 -112.01)",
    fill: "#D0F4FB",
    r: 3.249
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_204_6328)",
    "data-tip": "true",
    "data-for": "cml-tooltip",
    "data-product": "cml",
    className: "product cml"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.202 250.868c-.084 1 .535 2.016 1.858 2.78l117.097 67.601c2.487 1.436 6.52 1.436 9.007 0l117.085-67.595c1.323-.763 1.942-1.779 1.858-2.779 2.743 2.431 2.177 5.65-1.396 7.713l-115.295 66.561c-3.731 2.154-9.78 2.153-13.511-.001l-115.306-66.567c-3.573-2.063-4.14-5.282-1.397-7.713Z",
    fill: "#81E3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 145.549,
    height: 145.564,
    rx: 4,
    transform: "scale(1.22477 .70707) rotate(-45 548.899 -112.803)",
    fill: "url(#paint4_linear_204_6328)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 145.549,
    height: 145.564,
    rx: 4,
    transform: "scale(1.22477 .70707) rotate(-45 548.899 -112.803)",
    fill: "url(#paint5_linear_204_6328)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_204_6328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.035 240.16c-13.629.03-33.119.071-45.463 7.197-13.438 7.758-13.984 20.032-.491 27.934l.57.329 10.692-6.172a288.82 288.82 0 0 1-.57-.329c-7.472-4.447-6.887-11.166.633-15.508 6.856-3.958 14.249-4.096 43.173-4.635 4.385-.081 8.766-.175 13.148-.269 6.783-.145 12.48-.267 18.914-3.981 8.716-5.033 8.378-13.387-.454-18.486l-.571-.329-10.692 6.173.571.329c1.368.79 2.388 1.998 2.401 3.108.013 1.109-.739 2.171-2.089 2.95-3.542 2.045-13.691 1.855-20.84 1.722-2.981-.057-5.952-.038-8.932-.033Z",
    fill: "url(#paint6_linear_204_6328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.044 249.12c2.336-.047 4.842-.094 7.535-.144 2.663-.05 5.327-.103 7.99-.16l-.006.886c-.05 7.868-.122 19.12-12.466 26.246-13.498 7.792-35.771 7.567-49.446-.328l-.57-.329 10.692-6.173.57.33c7.692 4.44 20.329 4.629 27.921.246 6.219-3.59 6.992-7.434 7.78-20.574Z",
    fill: "url(#paint7_linear_204_6328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.385 240.263c-2.571.02-5.145-.028-7.417-.071a343.461 343.461 0 0 0-7.388-.035l.045-1.201c.06-.608.097-1.2.135-1.777.25-3.916.461-7.205 6.895-10.919 8.433-4.869 22.979-4.958 30.962-.349l.57.329-10.692 6.172-.57-.329c-3.422-1.975-7.986-.405-9.435.432-2.417 1.395-3.032 4.564-3.105 7.748Z",
    fill: "url(#paint8_linear_204_6328)"
  })), /*#__PURE__*/React.createElement("circle", {
    transform: "scale(1.22477 .70706) rotate(-45 725.72 -185.125)",
    fill: "#D0F4FB",
    r: 3.249
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_204_6328)",
    "data-tip": "true",
    "data-for": "tpi-tooltip",
    "data-product": "tpi",
    className: "product tpi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.831 323.968c-.084 1 .535 2.016 1.858 2.78l117.097 67.601c2.487 1.436 6.52 1.436 9.007 0l117.085-67.594c1.323-.764 1.942-1.78 1.858-2.78 2.743 2.431 2.177 5.65-1.396 7.713l-115.295 66.561c-3.731 2.154-9.78 2.153-13.511-.001l-115.306-66.567c-3.573-2.063-4.14-5.282-1.397-7.713Z",
    fill: "#81E3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 145.549,
    height: 145.564,
    rx: 4,
    transform: "scale(1.22477 .70707) rotate(-45 725.39 -185.914)",
    fill: "url(#paint9_linear_204_6328)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 145.549,
    height: 145.564,
    rx: 4,
    transform: "scale(1.22477 .70707) rotate(-45 725.39 -185.914)",
    fill: "url(#paint10_linear_204_6328)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_204_6328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M528.267 299.443c7.725-3.793 19.608-4.327 28.459-.252l.547.251c6.447 2.968 9.353 7.815 7.458 12.438-1.492 3.638-1.996 7.39-1.495 11.122l1.319 9.824c.287 2.14 3.524 3.745 7.229 3.586 3.706-.16 6.477-2.023 6.19-4.163l-1.319-9.825c-.394-2.93.002-5.876 1.174-8.733 3.096-7.552-1.652-15.469-12.184-20.318l-.546-.252c-20.139-9.272-50.078-3.651-56.821 10.667l-.256.544a17.297 17.297 0 0 1 2.268-1.551c4.89-2.823 11.623-3.935 17.977-3.338Z",
    fill: "url(#paint11_linear_204_6328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.085 301.31c-1.725.526-3.343 1.207-4.794 2.045-4.594 2.652-6.48 6.277-5.661 9.734-6.672 4.458-7.649 11.367-.55 16.505l1.009.731c4.791 3.469 12.615 5.032 20.078 4.013a125.044 125.044 0 0 1 20.948-1.065l16.576.544c3.711.121 6.558 1.956 6.358 4.099-.199 2.142-3.37 3.78-7.081 3.658l-16.576-.543a102.011 102.011 0 0 0-17.089.868c-12.535 1.713-25.678-.914-33.727-6.74l-1.009-.731c-16.061-11.626-6.326-28.91 18.476-32.803l1.142-.179c.635-.1 1.273-.143 1.9-.136Z",
    fill: "url(#paint12_linear_204_6328)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M550.666 317.812c-4.604-5.473-12.636-9.737-22.466-11.926l4.813-7.249c13.02 2.901 23.658 8.548 29.756 15.797l14.051 16.701c1.626 1.932.234 4.255-3.108 5.188-3.343.932-7.37.122-8.996-1.81l-14.05-16.701Z",
    fill: "url(#paint13_linear_204_6328)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M537.681 326.41c-10.405-2.823-18.501-7.878-22.559-14.087l-12.591 2.725c5.299 8.107 15.87 14.707 29.457 18.393l27.863 7.558c3.367.913 7.372.08 8.944-1.862 1.573-1.941.117-4.256-3.25-5.169l-27.864-7.558Z",
    fill: "#13ADC7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.576 299.656c-20.491-6.843-43.629 6.515-31.776 18.345l12.185-3.252c-4.948-4.939 5.7-11.086 14.255-8.229l5.336-6.864Zm32.044 47.814c-.57-2.121 1.945-4.103 5.618-4.425l.582-.051c2.904-.256 5.179-1.569 5.621-3.246l.089-.336c.559-2.12 3.991-3.572 7.665-3.243 3.675.329 6.2 2.314 5.641 4.435l-.088.336c-1.326 5.029-8.153 8.97-16.864 9.735l-.582.052c-3.673.322-7.112-1.136-7.682-3.257Z",
    fill: "#13ADC7"
  })), /*#__PURE__*/React.createElement("circle", {
    transform: "scale(1.22477 .70707) rotate(-45 902.21 -258.236)",
    fill: "#D0F4FB",
    r: 3.249
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_204_6328)",
    "data-tip": "true",
    "data-for": "dvc-tooltip",
    "data-product": "dvc",
    className: "product dvc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.955 250.862c-.084 1 .535 2.016 1.858 2.78l117.097 67.601c2.487 1.436 6.52 1.436 9.007 0l117.085-67.594c1.323-.764 1.942-1.78 1.858-2.78 2.743 2.431 2.177 5.65-1.396 7.713l-115.295 66.561c-3.731 2.154-9.78 2.153-13.511 0L45.352 258.575c-3.573-2.063-4.14-5.282-1.397-7.713Z",
    fill: "#81E3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 145.549,
    height: 145.564,
    rx: 4,
    transform: "scale(1.22477 .70707) rotate(-45 445.503 136.788)",
    fill: "url(#paint14_linear_204_6328)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 145.549,
    height: 145.564,
    rx: 4,
    transform: "scale(1.22477 .70707) rotate(-45 445.503 136.788)",
    fill: "url(#paint15_linear_204_6328)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_204_6328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m164.635 238.61 9.758 16.311-.374.216-30.203-6.043c3.725.851 7.143 2.048 10.126 3.549 4.427 2.123 6.865 4.936 7.774 8.137l29.514 5.685c.674.106 1.228.034 1.696-.236l.586-.338c.456-.264.592-.577.409-.967L184 247.655c-5.274-.638-9.997-2.142-13.625-4.338-2.465-1.424-4.416-2.996-5.752-4.7l.012-.007Z",
    fill: "url(#paint16_linear_204_6328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.837 248.244c-7.88.009-14.473-1.678-20.098-4.926-5.647-3.259-8.611-7.065-8.607-11.645-.064-2.194.654-4.37 2.111-6.392 1.457-2.022 3.621-3.848 6.358-5.363 4.978-2.96 11.742-4.7 18.896-4.86 1.112-.023 1.659.28 1.639.872l.169 5.173c-.052.537-.532.814-1.419.819-3.983.113-7.739 1.092-10.511 2.741-1.516.838-2.7 1.856-3.471 2.984-.771 1.128-1.111 2.34-.996 3.553.079 1.217.574 2.415 1.457 3.523.883 1.108 2.137 2.105 3.688 2.934 2.163 1.334 4.967 2.263 8.05 2.667 3.082.405 6.3.266 9.236-.399 1.933-.455 3.676-1.14 5.115-2.013 2.817-1.552 4.541-3.661 4.864-5.926.073-.561.586-.832 1.516-.813l9.078.153c.984.002 1.466.305 1.468.91-.032 2.072-.779 4.119-2.199 6.02-1.419 1.901-3.482 3.617-6.069 5.05-2.616 1.576-5.765 2.827-9.253 3.675-3.488.848-7.243 1.276-11.033 1.257l.011.006Z",
    fill: "url(#paint17_linear_204_6328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.286 282.913-38.296-22.109a1.028 1.028 0 0 1-.347-.291.554.554 0 0 1-.115-.347.473.473 0 0 1 .077-.319.861.861 0 0 1 .299-.27l13.684-7.9c6.048-2.996 11.847-4.484 19.643-4.423 7.84.048 13.863 1.753 20.144 4.808 6.034 2.938 8.578 7.023 8.684 11.536.122 2.132-.522 4.256-1.893 6.237-1.362 1.97-3.427 3.753-6.059 5.234l-13.684 7.9a1.643 1.643 0 0 1-.473.176 2.194 2.194 0 0 1-.558.047 2.49 2.49 0 0 1-.597-.07 1.755 1.755 0 0 1-.498-.203l-.011-.006Zm-20.234-21.789 21.537 12.434 5.382-3.107c1.509-.831 2.688-1.842 3.456-2.961.768-1.12 1.106-2.322.992-3.524-.196-2.512-2.07-4.883-5.227-6.615-3.286-1.896-7.108-2.888-11.436-3.005a24.374 24.374 0 0 0-6.099.58c-1.938.443-3.689 1.121-5.135 1.988l-5.37 3.101 1.911 1.103-.011.006Z",
    fill: "url(#paint18_linear_204_6328)"
  })), /*#__PURE__*/React.createElement("circle", {
    transform: "scale(1.22477 .70707) rotate(-45 622.322 64.466)",
    fill: "#D0F4FB",
    r: 3.249
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_204_6328)",
    "data-tip": "true",
    "data-for": "studio-tooltip",
    "data-product": "studio",
    className: "product studio"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.212 397.074c-.084 1 .535 2.016 1.858 2.779l117.097 67.601c2.487 1.436 6.52 1.436 9.007 0L542.26 399.86c1.322-.764 1.942-1.78 1.857-2.78 2.744 2.431 2.177 5.651-1.396 7.713l-115.295 66.561c-3.73 2.154-9.779 2.154-13.51 0l-115.307-66.567c-3.573-2.063-4.14-5.283-1.397-7.713Z",
    fill: "#81E3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 145.549,
    height: 145.564,
    rx: 4,
    transform: "scale(1.22477 .70707) rotate(-45 798.504 -9.424)",
    fill: "url(#paint24_linear_204_6328)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 145.549,
    height: 145.564,
    rx: 4,
    transform: "scale(1.22477 .70707) rotate(-45 798.504 -9.424)",
    fill: "url(#paint25_linear_204_6328)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_204_6328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.362 404.4c.942 2.768-1.694 5.675-6.554 5.466 2.895.12 5.798-.146 8.486-.776 2.669-.627 5.046-1.606 6.943-2.858 1.897-1.253 3.26-2.744 3.98-4.354.73-1.628.807-3.33.225-4.978l-12.272-35.164c-.454-1.137-1.642-2.133-3.322-2.783-1.666-.649-3.702-.902-5.684-.705-.966.096-1.889.303-2.716.607-.827.304-1.541.7-2.101 1.165-1.129.946-1.566 2.112-1.214 3.243a7147.534 7147.534 0 0 1 14.22 41.131l.009.006Z",
    fill: "url(#paint26_linear_204_6328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.174 408.094-2.11-6.008c-.96-2.758 1.613-5.661 6.462-5.488 1.241.046 2.509.161 3.78.358l26.458 3.995c.56.085 1.144.098 1.707.035a5.292 5.292 0 0 0 1.545-.394c.455-.198.824-.455 1.079-.75.254-.295.389-.62.395-.953l1.872 5.511c.942 2.768-1.694 5.675-6.554 5.466a33.477 33.477 0 0 1-3.552-.351l-26.458-3.984a6.55 6.55 0 0 0-1.922-.008c-.624.091-1.197.274-1.662.531-.464.258-.805.581-.987.937-.184.358-.205.74-.061 1.109l.009-.005-.001-.001Z",
    fill: "url(#paint27_linear_204_6328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.145 407.994.03.1 7.971 20.455c.209.561.225 1.141.046 1.706s-.549 1.104-1.09 1.586c-1.089.963-2.802 1.631-4.769 1.857-1.989.224-4.05-.008-5.746-.648-1.712-.64-2.933-1.635-3.41-2.78l-7.97-20.455c-.647-1.65-.63-3.363.048-5.008.668-1.628 1.991-3.143 3.86-4.421 1.869-1.279 4.233-2.286 6.9-2.94 2.687-.658 5.6-.948 8.513-.849-4.842-.168-7.424 2.73-6.464 5.488l2.081 5.909Z",
    fill: "url(#paint28_linear_204_6328)"
  })), /*#__PURE__*/React.createElement("circle", {
    transform: "scale(1.22477 .70707) rotate(-45 975.326 -81.747)",
    fill: "#D0F4FB",
    r: 3.249
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_204_6328",
    x1: 145.549,
    y1: 0,
    x2: -19.265,
    y2: 118.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21304F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4883"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_204_6328",
    x1: 72.775,
    y1: 0,
    x2: 72.775,
    y2: 145.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8FAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9EFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_204_6328",
    x1: 311.632,
    y1: 196.215,
    x2: 272.847,
    y2: 178.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E51C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#945DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13ADC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_204_6328",
    x1: 311.23,
    y1: 186.111,
    x2: 325.436,
    y2: 187.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD5236"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_204_6328",
    x1: 145.549,
    y1: 0,
    x2: -19.265,
    y2: 118.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21304F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4883"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_204_6328",
    x1: 72.775,
    y1: 0,
    x2: 72.775,
    y2: 145.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8FAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9EFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_204_6328",
    x1: 392.059,
    y1: 247.552,
    x2: 450.96,
    y2: 246.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#945DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13ADC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_204_6328",
    x1: 402.982,
    y1: 261.655,
    x2: 441.494,
    y2: 261.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    stopColor: "#945DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E51C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_204_6328",
    x1: 432.264,
    y1: 240.279,
    x2: 432.311,
    y2: 227.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1497B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#13ADC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_204_6328",
    x1: 145.549,
    y1: 0,
    x2: -19.265,
    y2: 118.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21304F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4883"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_204_6328",
    x1: 72.775,
    y1: 0,
    x2: 72.775,
    y2: 145.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8FAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9EFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_204_6328",
    x1: 508.289,
    y1: 290.162,
    x2: 535.722,
    y2: 329.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#945DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46837"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_204_6328",
    x1: 526.13,
    y1: 316.058,
    x2: 548.39,
    y2: 346.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#945DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13ADC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_204_6328",
    x1: 539.379,
    y1: 305.532,
    x2: 549.412,
    y2: 337.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13ADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46837"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_204_6328",
    x1: 145.549,
    y1: 0,
    x2: -19.265,
    y2: 118.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21304F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4883"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_204_6328",
    x1: 72.775,
    y1: 0,
    x2: 72.775,
    y2: 145.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8FAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9EFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_204_6328",
    x1: 165.542,
    y1: 259.623,
    x2: 175.156,
    y2: 276.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E51C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945DD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_204_6328",
    x1: 186.842,
    y1: 233.383,
    x2: 196.956,
    y2: 250.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD5236"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_204_6328",
    x1: 137.361,
    y1: 261.984,
    x2: 147.469,
    y2: 279.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13ADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1497B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_204_6328",
    x1: 145.549,
    y1: 0,
    x2: -19.265,
    y2: 118.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21304F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4883"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_204_6328",
    x1: 72.775,
    y1: 0,
    x2: 72.775,
    y2: 145.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8FAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9EFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_204_6328",
    x1: 252.558,
    y1: 291.905,
    x2: 250.348,
    y2: 353.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1497B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#13ADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#13ADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1497B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#13ADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13ADC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_204_6328",
    x1: 239.41,
    y1: 344.186,
    x2: 338.207,
    y2: 333.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB7341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F46837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F46837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD5236"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_204_6328",
    x1: 276.038,
    y1: 292.975,
    x2: 312.053,
    y2: 355.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#875DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#945DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#AE6CE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#945DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#875DC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_204_6328",
    x1: 145.549,
    y1: 0,
    x2: -19.265,
    y2: 118.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21304F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4883"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_204_6328",
    x1: 72.775,
    y1: 0,
    x2: 72.775,
    y2: 145.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8FAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9EFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_204_6328",
    x1: 439.868,
    y1: 384.372,
    x2: 452.69,
    y2: 406.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD5236"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_204_6328",
    x1: 407.798,
    y1: 394.817,
    x2: 440.956,
    y2: 408.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E51C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#945DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#945DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E51C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_204_6328",
    x1: 403.369,
    y1: 414.787,
    x2: 412.493,
    y2: 430.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13ADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1497B8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_204_6328",
    x: 0.345,
    y: 80.01,
    width: 714,
    height: 439.244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.324495 0 0 0 0 0.847248 0 0 0 0 0.935504 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_6328"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_204_6328",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_204_6328",
    x: 229.871,
    y: 140.946,
    width: 128.309,
    height: 76.074,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_6328"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_204_6328",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_204_6328",
    x: 353.124,
    y: 212.09,
    width: 135.061,
    height: 79.972,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_6328"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_204_6328",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_204_6328",
    x: 470.748,
    y: 279.991,
    width: 153.071,
    height: 90.369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_6328"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_204_6328",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_204_6328",
    x: 99.877,
    y: 211.435,
    width: 136.186,
    height: 80.621,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_6328"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_204_6328",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_204_6328",
    x: 222.003,
    y: 287.205,
    width: 136.063,
    height: 80.55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_6328"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_204_6328",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_204_6328",
    x: 352.009,
    y: 356.346,
    width: 137.312,
    height: 81.272,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_6328"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_204_6328",
    result: "shape"
  })))));
};

export { SvgProductsActive as ReactComponent };
export default __webpack_public_path__ + "static/products-active.dbf9432a.svg";